import { Platform } from 'react-native';
export function testIDProps(id) {
    let isTestIdsEnabled = false
    if (isTestIdsEnabled){
        if (Platform.OS === 'ios') {
             return { testID: id };
         }
        return { accessibilityLabel: id };
    }    
}